import {
  FileText,
  CheckSquare,
  Key,
  Activity,
  Users,
  FileSignature,
  PenTool,
  Files,
  Banknote,
  Mail,
} from 'lucide-react';

interface TabConfig {
  key: string;
  displayName: string;
  icon?: React.ComponentType<{ className?: string }>;
}

export const AGENT_TAB_CONFIG: Record<string, TabConfig> = {
  documents: {
    key: 'documents',
    displayName: 'Documents',
    icon: FileText,
  },
  tasks: {
    key: 'tasks',
    displayName: 'Tasks',
    icon: CheckSquare,
  },
  'key-transaction-facts': {
    key: 'key-transaction-facts',
    displayName: 'Key Transaction Facts',
    icon: Key,
  },
  'activity-log': {
    key: 'activity-log',
    displayName: 'Activity Log',
    icon: Activity,
  },
  contacts: {
    key: 'contacts',
    displayName: 'Contacts',
    icon: Users,
  },
  'transaction-template-documents': {
    key: 'transaction-template-documents',
    displayName: 'Forms',
    icon: FileSignature,
  },
  'signature-requests': {
    key: 'signature-requests',
    displayName: 'Signature Requests',
    icon: PenTool,
  },
} as const;

export enum TransactionDetailsTab {
  Workspace = 'workspace',
  Tasks = 'tasks',
  KeyTransactionFacts = 'key-transaction-facts',
  ActivityLog = 'activity-log',
  EmailLog = 'email-log',
  Contacts = 'contacts',
  SignatureRequests = 'signature-requests',
  Payments = 'payments',
  RequestSignatures = 'request-signatures',
  RevisionRequest = 'revision-request',
}

export const AGENT_TAB_CONFIG_V2: Record<string, TabConfig> = {
  [TransactionDetailsTab.Workspace]: {
    key: 'workspace',
    displayName: 'Workspace',
    icon: Files,
  },
  [TransactionDetailsTab.Tasks]: {
    key: 'tasks',
    displayName: 'Tasks',
    icon: CheckSquare,
  },
  [TransactionDetailsTab.KeyTransactionFacts]: {
    key: 'key-transaction-facts',
    displayName: 'Key Transaction Facts',
    icon: Key,
  },
  [TransactionDetailsTab.ActivityLog]: {
    key: 'activity-log',
    displayName: 'Activity Log',
    icon: Activity,
  },
  [TransactionDetailsTab.EmailLog]: {
    key: 'email-log',
    displayName: 'Email Log',
    icon: Mail,
  },
  [TransactionDetailsTab.Contacts]: {
    key: 'contacts',
    displayName: 'Contacts',
    icon: Users,
  },
  [TransactionDetailsTab.SignatureRequests]: {
    key: 'signature-requests',
    displayName: 'Signature Requests',
    icon: PenTool,
  },
  [TransactionDetailsTab.Payments]: {
    key: 'payments',
    displayName: 'Payments',
    icon: Banknote,
  },
  [TransactionDetailsTab.RequestSignatures]: {
    key: 'request-signatures',
    displayName: 'Prepare for Signatures',
    icon: FileSignature,
  },
  [TransactionDetailsTab.RevisionRequest]: {
    key: 'revision-request',
    displayName: 'Revisions',
    icon: FileSignature,
  },
} as const;
